var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1275 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 8.30889C5.68342 7.89704 6.31658 7.89704 6.70711 8.30889L12 13.8908L17.2929 8.30889C17.6834 7.89704 18.3166 7.89704 18.7071 8.30889C19.0976 8.72073 19.0976 9.38847 18.7071 9.80032L13.4142 15.3822C12.6332 16.2059 11.3668 16.2059 10.5858 15.3822L5.29289 9.80032C4.90237 9.38847 4.90237 8.72073 5.29289 8.30889Z",
    fill: "#006B6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdown);
export default __webpack_public_path__ + "static/media/ic_dropdown.28b2a1b7901d923b2dcd6ad96c8dd1ba.svg";
export { ForwardRef as ReactComponent };